import LoadingButton from "@mui/lab/LoadingButton";

export const LoginButton = (props) => (
  <LoadingButton variant="contained" color="primary" fullWidth {...props} />
);
